import React from 'react';
export function ProblemReveal() {
  return <div className="space-y-6" data-id="element-242">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-243">
        The Hidden Barrier That's Blocking Your Skincare (And Why Your Products
        Stopped Working)
      </h2>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-244">
        <img src="https://v.fastcdn.co/u/958c8c8b/64426513-0-shutterstock-1099159.jpg" alt="Diagram showing skin layers and permeability barrier" className="w-full h-full object-cover rounded-lg" data-id="element-245" />
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-246">
        My dermatologist explained that as we age—particularly after menopause—
        <b data-id="element-247">our skin builds what scientists call a "Permeability Wall".</b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-248">
        It's a protective barrier that gets thicker and more impenetrable
        starting in our 40s and becomes significantly worse in our 50s and 60s.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-249">
        And here's the devastating part: 99.7% of skincare products can't
        penetrate it.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-250">
        All those expensive serums? They're sitting on top of dead skin cells.
        Never reaching the living skin underneath where they could actually
        work.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-251">
        <b data-id="element-252">That's why your favorite products stopped delivering results.</b>
      </p>

      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-253">
        It's not that they're bad products. Your skin literally won't let them
        in anymore.
      </p>
      <div className="bg-pink-50 border-l-4 border-pink-500 p-6 my-6" data-id="element-254">
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-255">
          No matter how expensive your cream is. No matter how many
          "breakthrough ingredients" it contains. If it can't get past the
          Permeability Wall, it's completely useless.
        </p>
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-256">
        <b data-id="element-257">
          For years, the only solution was medical treatments—costly
          dermatologist visits where they'd use needles or lasers to force
          ingredients past that barrier.
        </b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-258">
        I'd spent thousands on these treatments. They worked, but they were
        expensive, time-consuming, and required appointments I had to schedule
        months in advance.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-259">
        Then my dermatologist showed me something that changed everything...
      </p>
    </div>;
}